import { render, staticRenderFns } from "./event-list.vue?vue&type=template&id=e0bc15e6&"
import script from "./event-list.vue?vue&type=script&lang=js&"
export * from "./event-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports